import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { AuthService } from "../../../services/api/auth/auth.service";
import { Router } from "@angular/router";
import { LangSwitchComponent } from "../../../shared/components/lang-switch/lang-switch.component";
import { first } from "rxjs";

@Component({
  standalone: true,
  selector: "app-otp",
  imports: [ReactiveFormsModule, TranslateModule, ButtonComponent, InputTextModule, LangSwitchComponent],
  templateUrl: "./otp.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./otp.component.scss",
})
export class OtpComponent {
  public form = new FormGroup({
    otp: new FormControl("", [Validators.required]),
  });

  private auth = inject(AuthService);
  private router = inject(Router);
  /**
   * Handle Enter key press event.
   * If pressed, calls `confirmOtp` method.
   * @param event KeyboardEvent
   */
  onKeyUp(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.confirmOtp();
    }
  }

  /**
   * Confirms the OTP entered by the user.
   * Validates the form and retrieves the OTP value. If valid, it calls
   * the AuthService to confirm OTP activation and navigates to the
   * password set page on success. Logs any errors encountered.
   */
  confirmOtp() {
    const otp = this.form.get("otp")?.value;
    if (this.form.valid && otp) {
      this.auth
        .confirmOtpActivation(otp)
        .pipe(first())
        .subscribe({
          next: (res) => {
            if (res) {
              this.router.navigateByUrl("/passwordSet");
            }
          },
        });
    }
  }
}
